import { NavLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changeOrderType } from "../../orders/ordersSlice";
import { AnimatePresence, motion } from "framer-motion";

import { FixedButton } from "../../template/buttons/fixed-button/fixed-button";

import { ReactComponent as CartIcon } from "../../../assets/images/icons/cart.svg";
import { ReactComponent as MenuIcon } from "../../../assets/images/icons/menu.svg";
import { ReactComponent as HistoryIcon } from "../../../assets/images/icons/history.svg";


import './footer.css';




export const Footer = () => {
    const hasPayment = useSelector(state => state.header.hasPayment);
    const count = useSelector(state => state.cart.count);console.log(count);
    const dispatch = useDispatch();
    const location = useLocation();

    // const isMenu = location.pathname.includes('/category/') || location.pathname.includes('/product/')  || location.pathname.includes('/search');

    const isMenu =  location.pathname === '/';

    const isCart = location.pathname.includes('/shipping') || location.pathname.includes('/checkout');

    if (!hasPayment) {
        return null;
    }

    const footerAnimate = {
        open: {opacity: 1, y: '0vh'},
        closed: {opacity: 0, y: '100vh'}
    };

    return (
       <>
            {isMenu &&
            <AnimatePresence mode="wait">
                <motion.footer
                    initial="closed"
                    animate={count ? 'open' : 'closed'}
                    exit="closed"
                    variants={footerAnimate}
                    transition={{duration: 0.5}}
                >
                    <FixedButton title={'В кошик'} count={count} link='/cart' className="cart-button"/>
                    {/* <div className="row">
                        <div className="col">
                            <NavLink 
                                to='/' 
                                className={`nav-link сustom ${isMenu ? 'active' : ''}`}
                                >
                                <MenuIcon/>
                                <span>Меню</span>
                            </NavLink>
                        </div>
                        <div className="col ">
                            <NavLink to='/cart' className={`nav-link сustom ${isCart ? 'active' : ''} position-relative`}>
                                {count !== 0 &&
                                    <div className="position-absolute top-0 translate-middle badge rounded-pill">{count}</div>
                                }
                                <CartIcon/>                       
                                <span>Кошик</span>
                            </NavLink>
                        </div>
                        <div className="col">
                            <NavLink onClick={() => dispatch(changeOrderType('actual'))} to='/orders' className={`nav-link сustom`}>
                                <HistoryIcon/>
                                <span>Замовлення</span>
                            </NavLink>
                        </div>
                    </div> */}
                </motion.footer>
            </AnimatePresence>
        }
       </>
    )
}